// Operator Inbox — Closed Signals tab (DEV-16232). Reverse-chronological
// list of resolved signals; clicking a row opens its read-only detail
// in the same right-pane drawer the Active tab uses.
import { createFileRoute } from '@tanstack/react-router';

import { InboxShell } from '../../components/inbox/InboxShell';
import { parseInboxSearch } from '../../components/inbox/inbox-search';

export const Route = createFileRoute('/inbox/closed-signals')({
  component: ClosedSignalsPage,
  validateSearch: parseInboxSearch,
});

function ClosedSignalsPage() {
  return <InboxShell tab="closed" />;
}
